// extracted by mini-css-extract-plugin
export default {"tableRecommended":"interested_tableRecommended__YXhXm","panelSelect":"interested_panelSelect__w6cRe"};